<div class="grid grid-cols-1 gap-4 mt-1 rounded-xl ">
  <div class="bg-white rounded-lg">
    <div class="flex flex-col md:flex-row justify-between items-center p-4 md:px-6 gap-3">

        <div class="w-full flex flex-wrap gap-2 md:w-auto">
            <input type="search" class="input-c !w-52" placeholder="Customer Product Code"
                   [(ngModel)]="searchParams().customerProductCode"
                   (keyup.enter)="getAllProducts()" (search)="getAllProducts()" />
            <input type="search" class="input-c !w-52" placeholder="FG Code"
                   [(ngModel)]="searchParams().productCode"
                   (keyup.enter)="getAllProducts()" (search)="getAllProducts()" />
            <input type="search" class="input-c !w-40" placeholder="Product name"
                   [(ngModel)]="searchParams().productName"
                   (keyup.enter)="getAllProducts()" (search)="getAllProducts()" />
            <input type="search" class="input-c !w-40" placeholder="Customer"
                   [(ngModel)]="searchParams().customer"
                   (keyup.enter)="getAllProducts()" (search)="getAllProducts()" />
            <button type="button" (click)="getAllProducts()" class="button-blue w-full sm:w-auto">
                Search
            </button>
        </div>
     
      <div class="w-full md:w-auto flex gap-2">
        <button type="button" (click)="createProduct()"
                class="button-blue w-full sm:w-auto">
          Create Product
        </button>
        <button type="button" (click)="openFileUploadModal()"
                class="button-blue w-full sm:w-auto">
          Upload Product File
        </button>
      </div>
    </div>
    <div class="md:mx-6 md:mb-6 overflow-x-auto">
      <table class="w-full text-sm text-left rtl:text-right text-gray-500 table-auto">
        <thead class="text-xs whitespace-nowrap text-gray-700 bg-gray-50">
        <tr>
          <th class="px-3 py-2 md:px-4 md:py-3">FG code</th>
          <th class="px-3 py-2 md:px-4 md:py-3">Product Name</th>
          <th class="px-3 py-2 md:px-4 md:py-3">Department</th>
          <th class="px-3 py-2 md:px-4 md:py-3">Customer</th>
          <th class="px-3 py-2 md:px-4 md:py-3">Actions</th>
        </tr>
        </thead>
        <tbody>
          @for (product of products(); track product._id) {
            <tr class="bg-white border-b whitespace-nowrap hover:bg-gray-50 text-gray-600">
              <td class="px-3 py-2 md:px-4 md:py-1.5">{{ product.productCode }}</td>
              <td class="px-3 py-2 md:px-4 md:py-1.5">{{ product.generalData?.productName }}</td>
              <td class="px-3 py-2 md:px-4 md:py-1.5 uppercase">{{ product.department  }}</td>
              <td class="px-3 py-2 md:px-4 md:py-1.5">{{ product.generalData?.customer }}</td>
              <td class="px-2 py-4">
                <div class="flex items-center gap-2">

                  <button
                    type="button"
                    (click)="openProcductViewModal(product.productCode)"
                    class="button-blue-outline w-full sm:w-auto"
                    title="View Product"
                  >
                   View
                  </button>

                  <button
                    type="button"
                    (click)="openProductEdit(product.productCode)"
                    class="button-blue-outline w-full sm:w-auto"
                    title="Edit Product"
                  >
                  Edit
                  </button>
                </div>
              </td>

            </tr>
          } @empty {
            <tr>
              <td colspan="9" class="px-6 py-10">
                <div class="flex flex-col items-center justify-center text-center">
                  <p class="text-md font-semibold text-gray-700 mb-2">No result found</p>
                  <p class="text-gray-500">We couldn't find any search result that match your search
                    criteria.</p>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
      <div class="mt-4">
        <app-table-pagination [totalItems]="totalItems()" [itemsPerPage]="itemsPerPage()"
                              (pageChanged)="onPageChange($event)"></app-table-pagination>
      </div>
    </div>
  </div>
</div>

@if(modal.$$showExelUploadModal()) {
    <div id="artwork-modal" tabindex="-1" aria-hidden="true" (keyup.escape)="closeFileUploadModal()"
         class="fixed inset-0 z-50 flex justify-center items-center overflow-y-auto bg-gray-900 bg-opacity-50">
      <div class="relative p-4 w-full max-w-4xl max-h-full">
        <div class="relative bg-white rounded-lg shadow-xl">
          <div class="flex items-center justify-between p-4 md:p-6 border-b rounded-t">
            <h3 class="text-lg font-semibold text-gray-900">
              Upload Products
            </h3>
            <button (click)="closeFileUploadModal()" type="button"
                    class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center transition-colors">
              <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                   viewBox="0 0 14 14">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
              </svg>
              <span class="sr-only">Close modal</span>
            </button>
          </div>
          <div class="pt-4">
              <div class="p-4">
                  <div class="flex flex-col items-center justify-center w-full">
                      <label
                        for="dropzone-file"
                        class="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:bg-gray-700 dark:border-gray-600 focus-within:ring-2 focus-within:ring-blue-500 focus-within:ring-offset-2"
                        role="button"
                        aria-describedby="file-upload-instructions"
                      >
                        <div class="flex flex-col items-center justify-center pt-5 pb-6">
                          <svg
                            class="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 20 16"
                          >
                            <path
                              d="M13 13h3a3 3 0 000-6h-.025A5.56 5.56 0 0016 6.5 5.5 5.5 0 005.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 000 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                              stroke="currentColor"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                            />
                          </svg>
                          <p id="file-upload-instructions" class="mb-2 text-xl text-gray-500">
                            <span class="font-semibold">Click to upload</span> or drag and drop
                          </p>
                          <p class="text-sm text-gray-500">
                            Only Excel (.xlsx, .xls) files are allowed
                          </p>
                        </div>
                        <input
                          id="dropzone-file"
                          type="file"
                          class="hidden"
                          (change)="onFileSelected($event)"
                          accept=".xlsx,.xls,.csv"
                        />
                      </label>
                    </div>  
              </div>
          </div>
        </div>
      </div>
    </div>
  }

@if (modal.$$showProcductViewModal()) {
  <div
    class="fixed inset-0 z-50 flex justify-center items-center overflow-y-auto bg-gray-900 bg-opacity-50"
    tabindex="-1"
    (keyup.escape)="closeProcductViewModal()"
  >
    <div class="relative p-4 w-full max-w-4xl max-h-full">
      <div class="relative bg-white rounded-lg shadow-xl">

        <!-- HEADER -->
        <div class="flex items-center justify-between p-4 md:p-6 border-b rounded-t">
          <h3 class="text-lg font-semibold text-gray-900">
            Product Details View
          </h3>

          <button
            type="button"
            (click)="closeProcductViewModal()"
            class="text-gray-400 hover:bg-gray-200 hover:text-gray-900 rounded-lg w-8 h-8 inline-flex justify-center items-center"
          >
            ✕
          </button>
        </div>

        <!-- BODY -->
        <div class="p-6 space-y-6">

          @if (selectedProduct()) {

            <!-- BASIC INFO -->
            <section class="border rounded-lg p-4">
              <h4 class="font-semibold mb-3">Basic Information</h4>

              <div class="grid grid-cols-2 gap-4 text-sm">
                <div>
                  <span class="text-gray-500">FG Code</span>
                  <p class="font-medium">{{ selectedProduct()?.productCode }}</p>
                </div>

                <div>
                  <span class="text-gray-500">Department</span>
                  <p class="font-medium">{{ selectedProduct()?.department }}</p>
                </div>
              </div>
            </section>

            <!-- GENERAL DATA -->
            @if (generalData()) {
              <section class="border rounded-lg p-4">
                <h4 class="font-semibold mb-3">General Data</h4>

                <div class="grid grid-cols-2 gap-4 text-sm">
                  <div>
                    <span class="text-gray-500">Product Name</span>
                    <p class="font-medium">{{ generalData()?.productName }}</p>
                  </div>

                  <div>
                    <span class="text-gray-500">Customer</span>
                    <p class="font-medium">{{ generalData()?.customer }}</p>
                  </div>

                  <div>
                    <span class="text-gray-500">Customer Product Code</span>
                    <p class="font-medium">{{ generalData()?.customerProductCode }}</p>
                  </div>

                  @if (generalData()?.category) {
                    <div>
                      <span class="text-gray-500">Category</span>
                      <p class="font-medium">{{ generalData()?.category }}</p>
                    </div>
                  }
                </div>

                <!-- REFERENCES -->
                @if (generalData()?.references?.length) {
                  <div class="mt-4">
                    <h5 class="font-medium mb-2">References</h5>

                    <table class="w-full text-sm border">
                      <thead class="bg-gray-100">
                        <tr>
                          <th class="p-2 text-left">Sales Order</th>
                          <th class="p-2 text-left">Quotation No</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (ref of generalData()?.references; track ref.salesOrder) {
                          <tr class="border-t">
                            <td class="p-2">{{ ref.salesOrder }}</td>
                            <td class="p-2">{{ ref.quotationNo }}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                }

                <!-- ARTWORK -->
                @if (generalData()?.artwork?.length) {
                  <div class="mt-4">
                    <h5 class="font-medium mb-2">Artwork</h5>
                    <ul class="list-disc pl-6 text-sm">
                      @for (art of generalData()?.artwork; track art.artworkNo) {
                        <li>{{ art.artworkNo }} – v{{ art.version }}</li>
                      }
                    </ul>
                  </div>
                }
              </section>
            }

            <!-- OFFSET -->
            @if (department() === 'Offset' && technicalData()) {
              <section class="border rounded-lg p-4">
                <h4 class="font-semibold mb-3">Offset Specifications</h4>

                <div class="grid grid-cols-3 gap-4 text-sm">
                  <div>
                    <span class="text-gray-500">Full Sheet Size</span>
                    <p class="font-medium">{{ technicalData()?.fullSheetSize }}</p>
                  </div>

                  <div>
                    <span class="text-gray-500">Cut Sheet Size</span>
                    <p class="font-medium">{{ technicalData()?.cutSheetSize }}</p>
                  </div>

                  <div>
                    <span class="text-gray-500">Product Size</span>
                    <p class="font-medium">{{ technicalData()?.productSize }}</p>
                  </div>
                </div>
              </section>
            }

            <!-- FLEXO -->
            @if (department() === 'Flexo' && technicalData()) {
              <section class="border rounded-lg p-4">
                <h4 class="font-semibold mb-3">Flexo Specifications</h4>

                <div class="grid grid-cols-3 gap-4 text-sm">
                  <div>
                    <span class="text-gray-500">Type</span>
                    <p class="font-medium">{{ technicalData()?.flexoType ?? '-' }}</p>
                  </div>

                  @if (technicalData()?.flexoType === 'Reel') {
                    <div>
                      <span class="text-gray-500">Core Size</span>
                      <p class="font-medium">{{ technicalData()?.coreSize ?? '-' }}</p>
                    </div>

                    <div>
                      <span class="text-gray-500">No of UPS</span>
                      <p class="font-medium">{{ technicalData()?.noOfUps ?? '-' }}</p>
                    </div>

                    <div>
                      <span class="text-gray-500">Pcs per Roll</span>
                      <p class="font-medium">{{ technicalData()?.pcsPerRoll ?? '-' }}</p>
                    </div>

                    <div>
                      <span class="text-gray-500">Winding Direction</span>
                      <p class="font-medium">{{ technicalData()?.windingDirection ?? '-' }}</p>
                    </div>
                  }

                  <div>
                    <span class="text-gray-500">Width (mm)</span>
                    <p class="font-medium">{{ technicalData()?.widthMm ?? '-' }}</p>
                  </div>

                  <div>
                    <span class="text-gray-500">Length (mm)</span>
                    <p class="font-medium">{{ technicalData()?.lengthMm ?? '-' }}</p>
                  </div>

                  <div>
                    <span class="text-gray-500">Remark</span>
                    <p class="font-medium">{{ technicalData()?.remark ?? '-' }}</p>
                  </div>
                </div>
              </section>
            }

            <!-- FINISHINGS -->
            @if (finishings().length) {
              <section class="border rounded-lg p-4">
                <h4 class="font-semibold mb-3">Finishings</h4>

                <div class="overflow-x-auto">
                  <table class="w-full text-sm border border-gray-300 table-fixed">
                    <thead class="bg-gray-100">
                      <tr>
                        <th class="p-2 text-left w-12">Seq</th>
                        <th class="p-2 text-left w-1/4">Process</th>
                        <th class="p-2 text-left w-1/4">Machine</th>
                        <th class="p-2 text-left">Remarks</th>
                      </tr>
                    </thead>

                    <tbody>
                      @for (f of finishings(); track f.sequence) {
                        <tr class="border-t">
                          <td class="p-2 text-center">{{ f.sequence }}</td>

                          <td class="p-2 truncate" title="{{ f.process }}">
                            {{ f.process }}
                          </td>

                          <td class="p-2 truncate" title="{{ f.machine }}">
                            {{ f.machine }}
                          </td>

                          <td class="p-2 break-words">
                            {{ f.remarks || '-' }}
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </section>
            }
          }
        </div>
      </div>
    </div>
  </div>
}
